<template>
    <div class="main club-entry">
        <div class="club-entry__step bcw">
            <van-steps :active="step">
                <van-step>基础信息</van-step>
                <van-step>等待审核</van-step>
                <van-step>入驻成功</van-step>
            </van-steps>
        </div>
        <form v-if="step == 0" @submit.prevent="checkForm" v-cloak>
            <h2 class="c6 fs2">基本信息</h2>
            <van-cell-group class="clear">
                <van-field
                    label="俱乐部名称"
                    v-model="club.title"
                    placeholder="请输入俱乐部名称"
                    required/>
                <van-field
                    label="俱乐部简介"
                    v-model="club.desc"
                    placeholder="请输入俱乐部简介"
                    required />
                <van-field
                    required
                    v-model="club.contact"
                    label="联系电话"
                    placeholder="请输入联系电话" />
                <van-cell
                    title="所在城市"
                    v-model="clubAreaTips"
                    @click="areaPopupShow = true"
                    is-link
                    required />
                <van-cell
                    title="选择位置"
                    v-model="clubGridTips"
                    is-link
                    @click="selectGrid"
                    required
                    value="北京" />
                <van-field
                    required
                    v-model="club.address"
                    input-align="right"
                    label="详细地址"
                    placeholder="" />
                
            </van-cell-group>
            <h2 class="c6 fs2">证件信息</h2>
            <van-cell-group class="clear">
                <van-field
                    required
                    label="身份证号"
                    v-model="club.idcard"
                    placeholder="请输入身份证号" />
                <p class="club-entry__description c9 fs2 ptm pbm">
                    1.身份证照片不得有遮挡，保证字迹清晰；<br>
                    2.请在白色背景下拍摄，保证证件边缘清晰；<br>
                    3.请从证件的正上方拍摄，防止画面变形
                </p>

                <van-row class="tac">
                    <van-col span="12">
                        <upload-file
                            ref="idcardfrontimg"
                            :id="'idcardFrontImg'"
                            @callBackImgUrl="getUploadedUrl">
                        </upload-file>                                               
                        <div class="mtm mbw fs1 c9">上传身份证正面照</div>
                    </van-col>
                    <van-col span="12">
                        <upload-file
                        :id="'idcardReverseImg'"
                        @callBackImgUrl="getUploadedUrl"></upload-file>
                        <div class="mtm mbw fs1 c9">上传身份证反面照</div>
                    </van-col>
                </van-row>
                <h4 class="fs2">营业执照</h4>
                <p class="club-entry__description c9 fs2 ptm pbm">
                    1.营业执照照片不得有遮挡，保证字迹清晰；<br>
                    2.请在白色背景下拍摄，保证证件边缘清晰；<br>
                    3.请从证件的正上方拍摄，防止画面变形
                </p>

                <van-row class="tac">
                    <van-col span="12">
                        <upload-file
                        :id="'businessLicense'"
                        @callBackImgUrl="getUploadedUrl"></upload-file>
                        <div class="mtm mbw fs1 c9">上传营业执照</div>
                    </van-col>
                </van-row>
            </van-cell-group>
            <h2 class="c6 fs2">俱乐部信息</h2>
            <van-cell-group class="clear">
                <van-field
                    required
                    label="规模"
                    v-model="club.scale"
                    placeholder="请输入，如场馆大小等" />
                <van-field
                    required
                    label="球桌数量"
                    v-model="club.tableNum"
                    placeholder="请输入" />
                <van-cell
                    title="营业时间"
                    v-model="clubTimeTips"
                    @click="timePopupShow = true"
                    is-link
                    required />
                <h4 class="fs2 mtm">商标LOGO</h4>
                <p class="club-entry__description c9 fs2 pbm">
                图片控制在10MB以内
                </p>

                <van-row class="tac">
                    <van-col span="12">
                        <upload-file
                            :id="'logo'"
                            @callBackImgUrl="getUploadedUrl"></upload-file>
                        <div class="mtm mbw fs1 c9">上传商标LOGO</div>
                    </van-col>
                </van-row>
            </van-cell-group>
            <!-- 选择城市弹出层 -->
            <van-popup v-model="areaPopupShow" position="bottom">
                <van-area
                    @cancel="areaPopupShow = false"
                    @confirm="getArea"
                    :area-list="arealist"/>
            </van-popup>
            <!-- 选择时间弹出层 -->
            <van-popup v-model="timePopupShow" position="bottom">
                <van-datetime-picker
                    type="time"
                    :max-minute="maxMinute"
                    :title="clubTimeTitle"
                    loading="true"
                    @cancel="timePopupShow = false;timeStep = 0"
                    @confirm="getTime"/>
            </van-popup>
            <!-- 选择位置坐标弹出层 -->
            <van-popup class="club-entry__grid" v-model="gridPopupShow">
                <iframe id="mapPage" width="100%" height="100%" frameborder=0
                    src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77&referer=myapp">                    
                </iframe>
            </van-popup>
            <the-btnbar></the-btnbar>
        </form>
        <div v-if="step == 1" class="bind_result_page">
            <div class="success-content">
                <div class="success-content_icon"><i class="iconfont green">&#xe6df;</i></div>                
                <div class="fs5 green">申请成功</div>
                <div class="success-content_tips c6 fs2">
                    <div>两个工作日内，我们工作人员会与您联系</div>
                    <div>请保持手机畅通，关注微信号，及时获取消息</div>
                </div>
                <div class="success-content_qrcode">
                    <img src="@/assets/imgs/leerweima.png" alt="">
                </div>
                <van-button class="mtm sureBtn" type="primary" size="large" @click="closePage('/venue')">确定</van-button>
            </div>
        </div>
        <div v-if="step == 2" class="bind_result_page">
            <div class="success-content">
                <div class="success-content_icon mtw mbw"><i class="iconfont green">&#xe6df;</i></div>                
                <div class="fs5 green mtw">审核通过</div>
                <div class="success-content_tips c6 fs2 mtm mbw">
                    <div>您已成为“{{clubInfo.title}}”的管理员，您可以前往后台完成相关设置。</div>
                </div>
                <van-button class="mtw sureBtn" type="primary" size="large" @click="closePage('/manage')">进入管理后台</van-button> 
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import func from "@/assets/scripts/func";
import router from '@/router';
import { Step, Steps,Field,Uploader,Row, Col,Popup,Area,Toast,Cell, CellGroup,DatetimePicker } from 'vant';
import UploadFile from '@/components/UploadFile';
import TheBtnbar from '@/components/TheBtnBar';
import AreaList from '@/assets/scripts/area';
Vue.use(Step).use(Steps).use(Field).use(Uploader).use(Row).use(Col).use(Popup).use(Area).use(Toast).use(Cell).use(CellGroup).use(DatetimePicker)
export default {
    name: 'ClubEntry',
    components:{
        UploadFile,TheBtnbar
    },
    data(){
        return {
            step: null,    // 入驻步骤
            maxMinute:0,
            club: {
                title: '',  // 名称
                desc: '',   // 简介
                contact: '',    // 联系方式
                province: '',   // 省编码
                city: '',   // 市编码
                county: '', //  区编码
                address: '',    // 详细地址
                longitude: '',  // 经度
                latitude: '',   // 维度

                idcard: '',     // 身份证号
                idcardFrontImg: '', // 身份证正面照片
                idcardReverseImg: '',   // 身份证背面照片

                logo: '',   // logo
                scale: '',  // 规模
                tableNum: '',   // 球桌数量
                businessLicense: '',    // 营业执照
                businessStartTime: '',  // 开始营业时间(只数字)
                businessEndTime: '',    // 开始营业时间(只数字)
            },
            startTime:'',  // 开始营业时间
            endTime:'',  // 开始营业时间
            clubAreaTips:'请选择',
            arealist:AreaList,
            areaPopupShow: false,

            clubGridTips:'请选择',
            gridPopupShow: false,

            clubTimeTips:'请选择',
            clubTimeTitle:'开始营业时间',
            timePopupShow: false,
            timeStep: 0,
            // showdiv:false
            clubInfo:'',   //俱乐部的信息
            idcardFrontImgHtml:'',   //获取身份证img
        }
    },
    computed: {
        timeGroup: function(){
          // 营业时间组合展示
            return this.startTime + ' - ' + this.endTime
        }
    },
    created() {
        let _this = this;       
        this.$http.post('club/getInfo').then(function(res){
            // console.log(res)
            if(res.data.value!=''){
                // 俱乐部入驻的资料
                _this.clubInfo = res.data.value 
                _this.club.title = _this.clubInfo.title
                _this.club.desc = _this.clubInfo.desc.replace(/<[^>]+>/g,"")   //过滤标签
                _this.club.contact = _this.clubInfo.contact  
                _this.club.address = _this.clubInfo.address
                _this.club.longitude = _this.clubInfo.longitude;
                _this.club.latitude = _this.clubInfo.latitude;
                _this.club.idcard = _this.clubInfo.idcard;
                _this.club.idcardFrontImg = _this.clubInfo.idcardFrontImg;
                // _this.$refs.idcardfrontimg.innerHTML = '<img src="'+_this.clubInfo.idcardFrontImg+'" class="upload-file__img">'
                _this.club.idcardReverseImg = _this.clubInfo.idcardReverseImg;
                _this.club.businessLicense = _this.clubInfo.businessLicense;
                _this.club.scale = _this.clubInfo.scale;
                _this.club.tableNum = _this.clubInfo.tableNum;
                _this.club.businessStartTime = _this.clubInfo.businessStartTime;
                _this.club.businessEndTime = _this.clubInfo.businessEndTime;
                // _this.clubTimeTips = _this.clubInfo.businessStartTime+":00-"+_this.clubInfo.businessEndTime+":00";   //展示出来的营业时间
                _this.club.logo = _this.clubInfo.logo;

                // 取当前入驻状态            
                if(res.data.value.status == 'applying'){
                    _this.step = 1;
                }else if(res.data.value.status == 'passed'){
                    _this.step = 2;
                }else{
                    _this.step=0;
                }
            }
        })
    },
    // beforeUpdate() {
    //   this.showdiv=true
    // },
    methods: {
        checkForm: function(){
          // 表单验证
            if(!this.club.title){
                Toast.fail('名称必填'); return false;
            }
            if(!this.club.desc){
                Toast.fail('简介必填'); return false;
            }
            if(!this.club.contact){
                Toast.fail('联系方式必填'); return false;
            }
            if(!this.club.province || !this.club.city || !this.club.county){
                Toast.fail('请选择所在城市'); return false;
            }
            if(!this.club.address){
                Toast.fail('请填写详细地址'); return false;
            }
            if(!this.club.longitude || !this.club.latitude){
                Toast.fail('请选择所在位置'); return false;
            }
            if(!this.club.idcard){
                Toast.fail('身份证号不能为空'); return false;
            }else if(!this.validIdcard(this.club.idcard)){
                Toast.fail('请填写正确身份证号'); return false;
            }
            if(!this.club.idcardFrontImg || !this.club.idcardReverseImg){
                Toast.fail('身份证正反面照片不能为空'); return false;
            }
            if(!this.club.businessLicense){
                Toast.fail('请上传营业执照'); return false;
            }
            if(!this.club.scale){
                Toast.fail('请填写场地规模'); return false;
            }
            if(!this.club.tableNum){
                Toast.fail('请填写球桌数量'); return false;
            }
            if(!this.startTime || !this.endTime){
                Toast.fail('请选择营业时间'); return false;
            }
            if(!this.club.logo){
                Toast.fail('请上传商标logo'); return false;
            }
            let _this = this;
            // 提交表单
            this.$http.post('club/create',_this.club).then(function(res){
                if(res.data.code == 0){
                    Toast('您的资料已经提交，请等待审核')
                    _this.step = 1
                }else{
                    Toast(res.data.message)
                }
            })
        },
        validIdcard:function(value){
            if (value && (!(/\d{17}[\d|x]|\d{15}/).test(value) || (value.length !== 15 && value.length !== 18))) {
                return false
            } else {
                return true
            }
        },
        selectGrid:function(){
            // 选择位置坐标
            let _this = this;
            window.addEventListener('message', function(event) {
                // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
                // console.log(event)
                var loc = event.data;
                if (loc && loc.module == 'locationPicker') {
                    //防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
                    _this.club.longitude = loc.latlng.lat;
                    _this.club.latitude = loc.latlng.lng;
                    _this.clubGridTips = loc.poiname;
                    _this.club.address = loc.poiaddress;
                    _this.gridPopupShow = false;
                    // console.log(loc)
                }
            }, false);
            this.gridPopupShow = true;
        },
        getArea: function(area){
          // 选择城市组件 选择后回调方法
            this.club.province = area[0].code;
            this.club.city = area[1].code;
            this.club.county = area[2].code;
            this.clubAreaTips = area[0].name + '-' + area[1].name + '-' + area[2].name;
            this.areaPopupShow = false;
        },
        getTime: function(time){
          // 营业时间组件 选择营业时间操作
            if(this.timeStep == 0){
                // 设置开始营业时间
                this.startTime = time;
                this.club.businessStartTime = time.substr(0, 2);
                this.timeStep = 1;
                Toast('请继续选择结束营业时间');
                this.clubTimeTitle = '结束营业时间';
            }else{
                // 设置结束营业时间
                this.endTime = time;
                this.club.businessEndTime = time.substr(0, 2);
                this.timeStep = 0;
                this.clubTimeTips = this.timeGroup;
                this.clubTimeTitle = '开始营业时间';
                this.timePopupShow = false;
            }
        },
        getUploadedUrl: function(url){
            // 上传组件上传完毕后数据处理
            // console.log(url)
            this.club[url.name] = url.url;
        },
        closePage:function(url){
            //关闭页面
            this.$router.push(url)
        }
    },
}
</script>
<style lang="less" scoped>
[v-cloak]{
    display: none;
}
.clear{    
  overflow: hidden;
}
.club-entry{
    h2{
        padding: .15rem;
    }
    h4{
        margin-left: .15rem;
        &::before {
            content: '*';
            position: absolute;
            left: 0.07rem;
            font-size: 0.14rem;
            color: #f44;
        }
    }
    &__step{
        padding: .1rem .15rem;
    }
    &__description{
        padding: 0 .15rem;
        line-height: 2;
    }
    &__grid{
        width: 100%; height: 100%;
        &>iframe{
            height: 100%;
        }
    }
}
// 申请成功
.bind_result_page {
  width:80%;margin:auto;
  padding-bottom: .2rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 2;
  .success-content {
    &_icon {
      height: 1.2rem;
      line-height: 1.5rem;      
      & i{
          font-size: .8rem;
      }
    }
    &_qrcode {
      width: 205px;
      height: 205px;
      margin: .1rem auto;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .fail-content {
    padding-bottom: 200px;
    &_icon {
      color: lighten(#EC284D, 10%);
      font-size: 100px;
    }
    &_subtitle {
      padding: 0 30px;
    }
  }
  .sureBtn{
      height: .5rem;
      line-height: .5rem;
      border-radius: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ClubEntry.vue